export class ListRestoreTemplatesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreTemplates",
            "baseName": "restoreTemplates",
            "type": "Array<RestoreTemplate>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "ListRestoreTemplatesResponsePagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListRestoreTemplatesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
